import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { identificationType } from "../../store/identificationType/actions";
export var useIdentificationTypeGetAll = function (trigger, description, code, page, limit) {
    var _a = useState(true), enable = _a[0], setEnable = _a[1];
    var dispatch = useDispatch();
    var _b = useSelector(function (state) { return ({
        responseIdentificationType: state.IdentificationType.responseIdentificationType,
        errorIdentificationType: state.IdentificationType.errorIdentificationType,
        loadingIdentificationType: state.IdentificationType.loadingIdentificationType,
    }); }), responseIdentificationType = _b.responseIdentificationType, errorIdentificationType = _b.errorIdentificationType, loadingIdentificationType = _b.loadingIdentificationType;
    useEffect(function () {
        if (trigger) {
            dispatch(identificationType({
                enable: enable,
                page: page,
                limit: limit,
                description: description,
                code: code,
            }));
        }
    }, [description, code, trigger]);
    return {
        responseIdentificationType: responseIdentificationType,
        errorIdentificationType: errorIdentificationType,
        loadingIdentificationType: loadingIdentificationType,
    };
};
